/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * All possible types of login methods, availability depends on permissions granted to the client.
 * @export
 * @enum {string}
 */
export enum FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType {
    ExchangeCode = 1,
    RefreshToken = 5,
    Unspecified = 10000,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType(value: any): boolean {
    for (const key in FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType) {
        if (Object.prototype.hasOwnProperty.call(FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType, key)) {
            if (FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType[key as keyof typeof FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSON(json: any): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType {
    return FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType {
    return json as FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSON(value?: FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType | null): any {
    return value as any;
}

export function FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType {
    return value as FxIdApplicationHandlersAuthAuthenticateToFxIdServicesProvidersEpicGamesStoreAuthDataLoginCredentialType;
}

